module.exports = __webpack_public_path__ + "img/breadcrumb-note.b4f732f5.svg";